import { Transforms, Editor} from 'slate'
import { MARK_LINE_HEIGHT, MARK_FONT_SIZE, MARK_COLOR, MARK_BACKGROUND_COLOR } from '../../../Marks';
import { MARK_BOLD, MARK_ITALIC, MARK_STRIKETHROUGH, MARK_UNDERLINE } from '@udecode/slate-plugins';

export const insertVariable = (editor, variable, options) => {
  const { type: variableType, ...rest } = variable;
  const marks = Editor.marks(editor)

  const variableNode = [{text: ' ' },{
    type: 'variable',
    children: [{ text: '' }],
    variableType,
    fontSize: marks[MARK_FONT_SIZE],
    lineHeight: marks[MARK_LINE_HEIGHT],
    color: marks[MARK_COLOR],
    backgroundColor: marks[MARK_BACKGROUND_COLOR],
    bold: marks[MARK_BOLD],
    italic: marks[MARK_ITALIC],
    strikethrough: marks[MARK_STRIKETHROUGH],
    underline: marks[MARK_UNDERLINE],
    ...rest,
    value: variable.value.length ? variable.value : variable.name,
  }, {text: ' ' }]
  Transforms.insertNodes(editor, variableNode);
  Transforms.move(editor);
};